import React from "react";
import RevShareModal from "../../common/overrides/RevShareModal";
import { CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS } from "../../../redux/actions/ActionTypes";

export default function CancelRequestModal(props) {
  return (
    <RevShareModal
      api={CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS}
      buttonText="Remove"
      buttonVariant="danger"
      modalSize="sm"
      selfClosing
      title="Cancel Request"
      yesButtonClickedText="Removing"
      yesButtonOnClick={clickCancel}
      yesButtonText="Remove"
      yesButtonVariant="danger"
    >
      <p>Are you sure you want to remove this RevShare request?</p>
    </RevShareModal>
  );

  function clickCancel() {
    return props.cancel(props.recordId);
  }
}
